module.exports = __webpack_public_path__ + "static/hero_sp_por-3ecca3a168c9bb59a24ceb252585561d.png";